// extracted by mini-css-extract-plugin
export default {"tooltip":"ep-z","sharingV2":"fp-z","sharingIconsV2":"gp-z","links":"hp-z","link":"ip-z","facebookV2":"jp-z","twitterV2":"kp-z","pinterestV2":"lp-z"};